import React, { useState } from 'react';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NameList from '../name_list/NameList';
import StaffCosts from '../staff_costs/StaffCosts';
import employeeService from '../../../services/employee.service';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import EmployeeCostImportModal from './EmployeeCostImportModal';
import employeeDetailFileService from '../../../services/employee_detail_file.service';
import { useFileUpload } from '@rd-web-markets/shared/dist/hooks';
import { FileUpload } from '@rd-web-markets/shared/dist/util';
import EmployeeDetailFiles from './EmployeeDetailFiles';
import EmployeeComments from './EmployeeComments';
import StaffCostTemplateImportStatus from '@rd-web-markets/shared/dist/claim_group/StaffCostTemplateImportStatus';
const acceptedStatusForDisable = ['pending', undefined];
const acceptedStatusToShowData = ['imported_successfully', 'imported_unsuccessfully', 'never_imported'];
const Employee = _ref => {
  let {
    selectedProjectId,
    selectedProject
  } = _ref;
  const {
    t
  } = useTranslation();
  const [key, setKey] = useState('name_list');
  const [showImportModal, setShowImportModal] = useState(false);
  const [data, setData, importStatus, importTemplate] = employeeService.useImportStatus(selectedProject.project_elster_detail.id);
  const [employeeDetailFiles, uploadEmployeeFile, deleteEmployeeFile] = employeeDetailFileService.useGetFiles(selectedProject.project_elster_detail.id);
  const [file, isFileUploadLoading, setFile] = useFileUpload(uploadEmployeeFile);
  const [emptyNameLists, setEmptyNameLists] = useState([]);
  const [emptyStaffCosts, setEmptyStaffCosts] = useState([]);
  const exportTemplate = employeeService.useExportTemplate;
  const disableImportExport = acceptedStatusForDisable.includes(importStatus.import_status);
  const employeesStyle = {
    display: acceptedStatusToShowData.includes(importStatus.import_status) ? 'block' : 'none'
  };
  const removeEmptyRow = rowIdToRemove => {
    if (key === 'name_list') {
      const newList = emptyNameLists.filter(emptyNameList => emptyNameList.emptyRowId !== rowIdToRemove);
      setEmptyNameLists([...newList]);
    } else if (key === 'staff_costs') {
      const newList = emptyStaffCosts.filter(emptyStaffCost => emptyStaffCost.emptyRowId !== rowIdToRemove);
      setEmptyStaffCosts([...newList]);
    }
  };
  const addContact = () => {
    const newEmptyRowData = {
      emptyRowId: 0,
      employee_name_number: '',
      year: 'after_30_06_2020',
      bda: false,
      fulltime: false,
      digital_record: false,
      sum_working_hr_rd: 0.0,
      rel_agreed_annual_working_hrs: 0.0,
      a1_exec_special_payment: 0.0,
      a2_sum_special_payments: 0.0,
      employers_social_security: 0.0,
      actual_working_time: 0,
      project_elster_detail_id: selectedProject.project_elster_detail.id,
      calculations: {
        share_of_working_time: null,
        sum_of_a1_a2: null,
        gross_wage: null,
        employer_social_security: null
      }
    };
    if (key === 'name_list' && !!emptyNameLists.length) {
      const largestId = Math.max(...emptyNameLists.map(emptyNameList => emptyNameList.emptyRowId));
      setEmptyNameLists([...emptyNameLists, {
        ...newEmptyRowData,
        emptyRowId: largestId + 1
      }]);
    } else if (key === 'name_list' && !emptyNameLists.length) {
      setEmptyNameLists([newEmptyRowData]);
    } else if (key === 'staff_costs' && !!emptyStaffCosts.length) {
      const largestId = Math.max(...emptyStaffCosts.map(emptyStaffCost => emptyStaffCost.emptyRowId));
      setEmptyStaffCosts([...emptyStaffCosts, {
        ...newEmptyRowData,
        emptyRowId: largestId + 1
      }]);
    } else if (key === 'staff_costs' && !emptyStaffCosts.length) {
      setEmptyStaffCosts([newEmptyRowData]);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmployeeCostImportModal, {
    show: showImportModal,
    onHide: () => setShowImportModal(false),
    importTemplate: importTemplate
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mt-4 mb-1"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "add",
    loading: false,
    onClick: () => {
      addContact();
    }
  }, t('add_contact'))), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "cloud_download",
    disabled: disableImportExport,
    loading: false,
    onClick: () => exportTemplate(selectedProject.project_elster_detail.id),
    className: "me-1"
  }, t('export_employee_data'))), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "cloud_upload",
    disabled: disableImportExport,
    loading: false,
    onClick: () => setShowImportModal(true)
  }, t('import_employee_data'))), /*#__PURE__*/React.createElement(Col, {
    md: 1,
    className: "d-flex justify-content-end"
  }, t('comments')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(EmployeeComments, {
    selectedProject: selectedProject
  })), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement(FileUpload, {
    loading: isFileUploadLoading,
    title: t('upload_document'),
    file: file,
    onSelectFile: setFile
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(StaffCostTemplateImportStatus, {
    importStatus: importStatus
  })), !!employeeDetailFiles.length && /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(EmployeeDetailFiles, {
    employeeDetailFiles: employeeDetailFiles,
    deleteEmployeeFile: deleteEmployeeFile
  }))), /*#__PURE__*/React.createElement("div", {
    style: employeesStyle
  }, /*#__PURE__*/React.createElement(Tabs, {
    onSelect: k => setKey(k),
    className: "mb-3 ms-3",
    defaultActiveKey: 'name_list'
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "name_list",
    title: t('name_list')
  }, /*#__PURE__*/React.createElement(NameList, {
    setData: setData,
    data: data,
    selectedProjectId: selectedProjectId,
    selectedProject: selectedProject,
    emptyNameLists: emptyNameLists,
    addContact: addContact,
    removeEmptyRow: removeEmptyRow
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "staff_costs",
    title: t('staff_costs')
  }, /*#__PURE__*/React.createElement(StaffCosts, {
    setData: setData,
    data: data,
    selectedProjectId: selectedProjectId,
    selectedProject: selectedProject,
    emptyStaffCosts: emptyStaffCosts,
    addContact: addContact,
    removeEmptyRow: removeEmptyRow
  })))));
};
export default Employee;